import { render, staticRenderFns } from "./MDviewcha.vue?vue&type=template&id=28a36808&scoped=true"
import script from "./MDviewcha.vue?vue&type=script&lang=js"
export * from "./MDviewcha.vue?vue&type=script&lang=js"
import style0 from "./MDviewcha.vue?vue&type=style&index=0&id=28a36808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a36808",
  null
  
)

export default component.exports